/** Shared hover-carousel timing for collection tiles (not stored in CMS). Matches home hero cadence. */
export const COLLECTION_HOVER_SLIDE_DURATION_MS = 3000;

export const GALLERY_PROJECTS_PER_PAGE = 10;
